<template>
    <Popup v-model="PopUpOpen" :title="props.journalReference" hasClose @update:modelValue="closeChild">
        <template #contents>
             <div class="grid-item">
                <div class="content-container">
                    <div class="content-container">
                        <div class="export-csv">
                            <ExportCsvModelAgnostic
                            :dataToDownload="tableObject!"
                            :fileName="'VCFS_Trial_Balance_Journal_Reference_Contents' + '_' + props.journalReference"
                            />
                        </div>
                        <div class="table-container">
                            <TableAgnosticModel
                            :Rows="tableObject"
                            :Cols="columnNames"
                            :Labels="labels"
                            >
                            <template #AmountTotal="{ value }">
                                <div>
                                    {{ MonetaryValueWithCommas(value.AmountTotal) }}
                                </div>
                            </template>
                            <template #AmountExVat="{ value }">
                                <div>
                                    {{ MonetaryValueWithCommas(value.AmountExVat) }}
                                </div>
                            </template>
                            <template #AmountVat="{ value }">
                                <div>
                                    {{ MonetaryValueWithCommas(value.AmountVat) }}
                                </div>
                            </template>
                            <template #Amount="{ value }">
                                <div>
                                    {{ MonetaryValueWithCommas(value.Amount) }}
                                </div>
                            </template>
                            </TableAgnosticModel>
                        </div>
                    </div>                    
                </div>
            </div>
        </template>
    </Popup>
</template>
<script setup lang="ts">
import { computed, ref, defineProps, watch } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "./Popup.vue";
import TableAgnosticModel from "./TableAgnosticModel.vue";
import ExportCsvModelAgnostic from "./ExportCsvModelAgnostic.vue";
import { MonetaryValueWithCommas } from "@/services/helpers/Helper";

const columnNames = ref<(string & keyof any)[]>([]);
const labels = ref<string[]>([]);
const props = defineProps<{
    modelValue?: boolean;
    tableRows?: Record<string, any>[];
    journalReference: string;
}>();
const tableObject = computed( () => {
    if (Array.isArray(props.tableRows) && props.tableRows.length > 0 && typeof props.tableRows[0] === 'object' && props.tableRows[0] !== null) {
        columnNames.value = Object.keys(props.tableRows[0]) as (string & keyof any)[];
        labels.value = columnNames.value.map(name => pascalCaseToWords(name));
    }
    return props.tableRows;
});
const PopUpOpen = computed<boolean>({
    get() {
        return props.modelValue ?? false; 
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});
const emits = defineEmits<{
    (e: 'update:modelValue', val: boolean): void;
    (e: 'confirm');
}>();

function pascalCaseToWords(str) {
  return str
    .replace(/([A-Z])/g, ' $1')
    .trim();
}
function closeChild() {
  PopUpOpen.value = false;
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/layout.scss";
.export-csv {
    display: flex;
    align-items: flex-end;
}
:deep(.vtl-container){
  overscroll-behavior: auto !important;
}
</style>